// React Query retry predicate that does NOT retry on 4xx (auth / client errors).
// Those won't succeed on retry, so failing immediately surfaces a clear error
// in the UI instead of a long spinner during the default retry backoff.
export var retryNon4xx = function (failureCount, error) {
    var _a;
    var status = (_a = error === null || error === void 0 ? void 0 : error.response) === null || _a === void 0 ? void 0 : _a.status;
    if (status && status >= 400 && status < 500)
        return false;
    return failureCount < 2;
};
